@let isMobile = breakpoints() === "mobile";
@if (titleDescription(); as titleDescription) {
  @let alignment = titleDescription.alignment ?? "left";
  @if (titleDescription.title; as title) {
    @let titleSizeOverride = titleDescription.titleSize || title.as;
    @let mobileSizeOverride = titleDescription.forceTitleSizeOnMobile || titleSizeOverride;
    @let titleSize = isMobile ? mobileSizeOverride : titleSizeOverride;
    <app-title
      [title]="title"
      [size]="titleSize"
      [ngClass]="{
        'text-center': alignment === 'center',
        'text-right': alignment === 'right',
      }" />
  }
  @if (titleDescription.description; as description) {
    <div
      [innerHTML]="description"
      handleHtmlLinks
      class="pt-4"
      [ngClass]="{
        'text-center': alignment === 'center',
        'text-right': alignment === 'right',
      }"></div>
  }
}
